import React from 'react';
import { Box, Button, Typography } from '@mui/material';

import appStore from '../../assets/footer/appStore.svg';
import googlePlay from '../../assets/footer/googlePlay.svg';

export const Footer = ({ colorBg = false }: { colorBg?: boolean }) => {
    return (
        <Box
            sx={{
                width: '100%',
                justifyContent: 'center',
                display: 'flex',
                backgroundColor: colorBg ? '#F6F9FC' : undefined,
            }}
        >
            <Box
                sx={{
                    maxWidth: '1256px',
                    width: '100%',
                    margin: '0 20px',
                    padding: '30px 0px',
                    borderTop: '1px solid #ECF0F4',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Typography
                    sx={{
                        color: '#0F0E0E',
                        fontFamily: 'AvenirNext500',
                        fontSize: '16px',
                        flexGrow: 1,
                    }}
                >
                    © 2023 Walken
                </Typography>
                <Box
                    sx={{
                        '& a': {
                            color: '#6E7379',
                            fontFamily: 'AvenirNext400',
                            fontSize: '16px',
                            lineHeight: 'normal',
                            textDecoration: 'none',
                            margin: '15px',
                            opacity: 0.8,
                            '&:hover': {
                                opacity: 1,
                            },
                        },
                    }}
                >
                    <a href="https://walken.io/terms-of-service" target="__blank">
                        Terms of use
                    </a>
                    <a href="https://walken.io/privacy-policy" target="__blank">
                        Privacy Policy
                    </a>
                </Box>
                <Box
                    sx={{
                        marginLeft: '15px',
                        display: 'flex',
                        gap: '10px',
                        '& button': {
                            backgroundColor: '#FFF',
                            borderRadius: '26px',
                            color: '#0F0E0E',
                            fontFamily: 'AvenirNext600',
                            lineHeight: 'normal',
                            fontSize: '16px',
                            textTransform: 'none',
                            padding: '15px 20px',
                        },
                    }}
                >
                    <Button
                        startIcon={<img src={appStore} alt="app store logo" />}
                        onClick={() => {
                            window.open('https://apps.apple.com/us/app/walken-io/id1594168445', '__blank');
                        }}
                    >
                        App Store
                    </Button>
                    <Button
                        startIcon={<img src={googlePlay} alt="google play logo" />}
                        onClick={() => {
                            window.open(
                                'https://play.google.com/store/apps/details?id=com.milkywayapps.walken&pli=1',
                                '__blank',
                            );
                        }}
                    >
                        Google Play
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};
